import { useContext } from 'react';
import {
  AuthContext,
  AuthContextType,
} from '@/hooks/providers/useAuthProvider';

const useAuth = (): AuthContextType => useContext(AuthContext);

export default useAuth;
